'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavLink = undefined;

var _NavLink = require('./NavLink');

Object.defineProperty(exports, 'NavLink', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NavLink).default;
  }
});

var _Link = require('./Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Link2.default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-first-router-link/dist/index.js
// module id = 170
// module chunks = 0